import React from 'react';
import { LoginUpperRightLayout } from 'layout';
import { RestorePassword } from '@isyc-react/auth/modules/pods/login';
export const RestorePasswordScene = () => {
    return (React.createElement(LoginUpperRightLayout, null,
        React.createElement(RestorePassword, { onSuccessLogUserIn: true })));
};
